module.exports = __webpack_public_path__ + "static/media/carousel-03.310babb8.jpg";